module.exports = __webpack_public_path__ + "img/131w.d6464c1.jpg";